import { defineComponent as _defineComponent } from 'vue'
import { vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a631e420"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"min-height":"75px"} }

import { computed, ref, watch } from "vue";
import Popup from "@/components/Popup.vue";
import Table from "@/components/TablePersistentChecking.vue";
import { DisplayableKeys } from "@/services/SorterService";
import IEoPVerificationRequestParams from "@/Interfaces/EoPVerifications/IEoPVerificationRequestParams";
import { eoPVerificationReport } from "@/services/network";
import EoPVerificationReportOperation from "@/Interfaces/EoPVerifications/EoPVerificationReportOperation";
import useNotifierWithErrFormatter from "@/services/composables/NotifierWithErrFormatter";
import { useRoute } from "vue-router";
import Spinner from '@/components/Spinner.vue';



export default /*#__PURE__*/_defineComponent({
  __name: 'EopVerificationReportHistoryPopUp',
  props: {
    modelValue: { type: Boolean }
  },
  emits: ["update:modelValue", "confirm"],
  setup(__props: any, { emit: __emit }) {

const historyCols: DisplayableKeys<EoPVerificationReportOperation>[] = ["Category", "EoPName", "ClosingDate", "PerformedOn", "PerformedBy","EoPStatus", "JournalingStatus", "AmountExpected", "AmountReceived", "AmountDeviation"];
const historyLabels = [ "Category", "Type", "Closing", "Processed", "User", "Status", "Journaling Status", "Amount Expected", "Amount Received", "Amount Deviation"];
const defaultSortCols= [ historyCols.findIndex((col) => col === "PerformedOn" as keyof EoPVerificationReportOperation ) ];
const defaultSortOrders = ref<(1|-1)[]>([-1]);
const route = useRoute();
const journalType = route.path.split("/").pop() as string;
const market = route.query.market?.toString() as string;
const period = route.query.period?.toString() as string;
const props = __props;
const isLoading = ref(false)
const pastEoPVerificationReports = ref<EoPVerificationReportOperation[]>();
const popUpOpen = computed({
    get() {
        return props.modelValue
    },
    set(val) {
        emits('update:modelValue', val);
    }
});
const emits = __emit;
watch(popUpOpen, (val) => {
    if(val == true){
        GetPastEoPVerificationReport(journalType, market, period)
    }
})

async function GetPastEoPVerificationReport(journalType: string, market: string, period: string) {
    if(isLoading.value == true) return
    try {
        isLoading.value = true
        const eoPRequest: IEoPVerificationRequestParams = {
            market: market, 
            period: period, 
            eoPType: journalType,
            mostRecentOnly: false
        }
        const data = (await eoPVerificationReport.get(eoPRequest)).data
        pastEoPVerificationReports.value = data
    } catch (error) {
        useNotifierWithErrFormatter().error({error, errorType: "Failed to download past EoP verification reports."});
    }
    finally{
        isLoading.value = false
    }
}
function closeChild(){
    popUpOpen.value = false;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Popup, {
    modelValue: popUpOpen.value == true,
    "onUpdate:modelValue": closeChild,
    title: "Previous Reports",
    hasClose: ""
  }, {
    contents: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _withDirectives(_createVNode(Spinner, null, null, 512), [
          [_vShow, isLoading.value ==true]
        ]),
        _createVNode(Table, {
          Rows: pastEoPVerificationReports.value,
          Cols: historyCols,
          Labels: historyLabels,
          DefaultSortCols: defaultSortCols,
          DefaultSortOrders: defaultSortOrders.value
        }, {
          PerformedOn: _withCtx((props) => [
            _createElementVNode("div", null, _toDisplayString(props.value.PerformedOn.replace("T", " ")), 1)
          ]),
          _: 1
        }, 8, ["Rows", "DefaultSortOrders"])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})